import { RefundModel } from 'api-hooks/refund/refund';
import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import { HeaderCheckbox } from 'legacy-modules/sales/reschedule/header-checkbox';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import GuestName from '../../guest-name-column';

interface Props {
  parentIndex: number;
  refund?: RefundModel;
}

function reducer(state, action, { update, clearErrors, name, setValue }) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            const tempValue = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
            };
            // update(action.rowIndex, tempValue);

            clearErrors(`${name}.${action.rowIndex}.${action.columnId}`);
            setValue(`${name}.${index}`, tempValue, { shouldValidate: true });

            return tempValue;
          }
          return row;
        }),
      };
    case 'update_all':
      return {
        ...state,
        data: action.newData,
      };
    case 'isSelected':
      return {
        ...state,
        data: state.data.map((row, index) => {
          const tempValue = {
            ...state.data[index],
            isSelected: action.value,
          };
          clearErrors(name);
          // update(index, tempValue);
          setValue(`${name}.${index}`, tempValue, { shouldValidate: true });

          return tempValue;
        }),
      };
    default:
      return state;
  }
}

export const _columns: (props: {
  t: any;
  editable: boolean;
  name: string;
  dispatch;
}) => IColumn<any>[] = ({ t, editable, dispatch, name }) => [
  {
    header: () => <HeaderCheckbox name={name} dispatch={dispatch} />,
    accessorKey: 'isSelected',
    minSize: 50,
    size: 50,
    checkboxNoLabel: true,
    dataType: ColumnDataType.checkbox,
  },
  {
    header: t('common:guest'),
    accessorKey: 'guestName',
    minSize: 150,
    dataType: ColumnDataType.null,
    disabled: true,
    cell: ({ row }) => {
      return <GuestName value={row.original.guestName} />;
    },
  },
  {
    header: t('common:other'),
    accessorKey: 'activityName',
    minSize: 250,
    maxSize: 250,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:type'),
    accessorKey: 'type',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.null,
    disabled: true,
  },
  {
    header: t('common:date'),
    accessorKey: 'date',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.date,
    disabled: true,
  },
  {
    header: t('common:price'),
    accessorKey: 'price',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    disabled: true,
  },
  {
    header: t('common:description'),
    accessorKey: 'description',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:refund_price'),
    accessorKey: 'refundPrice',
    minSize: 100,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
];

export default function GuestActivityDetailTable(props: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const [isInitiate, setIsInitiate] = React.useState<boolean>(false);
  const { control, clearErrors, setValue } = useFormContext();

  const name: any = `activityPurchases.${props.parentIndex}.activityPurchaseGuests`;

  const { fields, update } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const columns = (dispatch?: any) => _columns({ t, editable, dispatch, name });

  const [state, dispatch] = React.useReducer(
    (state, action) =>
      reducer(state, action, {
        update,
        clearErrors,
        name,
        setValue,
      }),
    {
      columns: columns(),
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate) {
      dispatch({
        type: 'update_all',
        newData: fields.length ? fields : [],
      });
      setIsInitiate(true);
    }
  }, [fields, isInitiate]);

  if (fields.length === 0) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns(dispatch)}
        data={state.data}
        dispatch={dispatch}
        noAddRemoveRow
        name={name}
        disabled={!editable || !!props.refund}
        uniqueRowKey="customId"
        onCustomDisabledCell={({ accessorKey, rowOriginal }) =>
          !!(accessorKey !== 'isSelected' && !rowOriginal.isSelected)
        }
      />
    </div>
  );
}
